<div class="title">Credit Alerts</div>

<div class="amount">{{ amount$ | async }}</div>

<a [routerLink]="['/alerts/list']" class="clickable">View Now</a>
